'use es6';

import { createSelector } from 'reselect';
export const getHistory = (_, props) => props.history;

const getHistoryByName = setting => createSelector([getHistory], history => history[setting]);

export const getHistoryCreateHref = getHistoryByName('createHref');
export const getHistoryPush = getHistoryByName('push');